import moment from "moment-timezone";
import {
    ONE,
    STEP_NAMES,
    ZERO,
    CHANNEL,
    NON_CREDIT,
    CREATE_ACCOUNT_DATE_FORMAT,
    TEN,
    COUNTRY_LIST
} from '../constants';
import { cookieValue } from '../../../../aem-core-components/utils/cookieUtils';
import { STORAGE_CONFIG } from '../../../../constants/storageConfig';
import { getDriverLicenseNumberForCanada } from './cashflowUtils';

export const createAccountPayload = formData => {
    const personalInfoData = formData[STEP_NAMES[ZERO]]?.data;
    const accountInfoData = formData[STEP_NAMES[ONE]]?.data;
    const emailId = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.GR_EMAIL);
    const isCountryCanada = accountInfoData?.country === COUNTRY_LIST[1].value;
    const isPhoneVerified = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.USER_PHONE_VERIFIED);
    const ersParamValue = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.ERS) || "";
    const otp = sessionStorage?.getItem(STORAGE_CONFIG.SESSION_STORAGE.CCA_VERIFICATION_CODE);
    return {
        email: emailId,
        ers: ersParamValue,
        phone: personalInfoData?.mobileNumber,
        firstName: personalInfoData?.firstName,
        lastName: personalInfoData?.lastName,
        password: personalInfoData?.password,
        isPunchOutUser: false,
        channel: CHANNEL,
        createDate: moment().format(CREATE_ACCOUNT_DATE_FORMAT),
        userType: NON_CREDIT,
        driverLicenseNumber: isCountryCanada ? getDriverLicenseNumberForCanada(): accountInfoData?.driversLicenseNumber,
        driverLicenseState: isCountryCanada ? accountInfoData?.state : accountInfoData?.driversLicenseState,
        address: [
            {
                type: '',
                city: accountInfoData?.city,
                country: accountInfoData?.country,
                line1: accountInfoData?.address,
                line2: accountInfoData?.address2,
                line3: '',
                postalCode: accountInfoData?.zipCode,
                state: accountInfoData?.state
            }
        ],
        dateOfBirth: personalInfoData?.dateOfBirth.toISOString().slice(ZERO, TEN),
        receivePromotionalInfo: accountInfoData?.isAgree,
        activate: true,
        smsOptIn: accountInfoData?.isSmsOptin,
        submissionId: sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.CCA_SUBMISSION_ID),
        clientIPAddress: sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.CLIENT_IP_ADDRESS),
        sbuid: cookieValue('sbuid') || '',
        sbaid: cookieValue('sbaid') || '',
        sbsid: sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.SBSID) || '',
        sbmid: sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.SBMID) || '',
        userPhoneVerified: isPhoneVerified == 'true',
        ...(isCountryCanada && {
            isConsent: accountInfoData?.isConsent === 'Yes',
        }),
        otp,
    };
};
